document.addEventListener("DOMContentLoaded", function () {

    // ✅ Utility to get current variant ID from URL
    function getCurrentVariantId() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('variant');
    }

    // ✅ Debounce function to prevent rapid multiple updates
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // ✅ Simple product JSON cache
    let productJSONCache = null;

    // ✅ Main function: fetch variant price and update per-unit prices
    function updatePerUnitPrices() {
        const currentVariantId = getCurrentVariantId();

        if (!currentVariantId) {
            console.log("[Per Unit Pricing] No variant ID found in URL.");
            return;
        }

        // Function to process product JSON and update prices
        function processProductJSON(product) {
            const variant = product.variants.find(v => v.id == currentVariantId);
            if (variant) {
                const newPrice = variant.price / 100; // Shopify returns price in cents

                var price5Display = document.getElementById("price-5");
                var price50Display = document.getElementById("price-50");
                var price100Display = document.getElementById("price-100");

                var formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

                if (price5Display) price5Display.innerText = formattedPrice.format(newPrice);
                if (price50Display) price50Display.innerText = formattedPrice.format(newPrice * 0.85);
                if (price100Display) price100Display.innerText = formattedPrice.format(newPrice * 0.70);

                console.log(`[Per Unit Pricing] Updated prices for variant ${currentVariantId}: $${newPrice}`);
            } else {
                console.warn("[Per Unit Pricing] Variant not found in product JSON.");
            }
        }

        // If cached, use it; otherwise, fetch
        if (productJSONCache) {
            processProductJSON(productJSONCache);
        } else {
            fetch(`${window.location.pathname}.js`)
                .then(response => response.json())
                .then(product => {
                    productJSONCache = product; // Cache it
                    processProductJSON(product);
                })
                .catch(error => {
                    console.error("[Per Unit Pricing] Error fetching product JSON:", error);
                });
        }
    }

    const debouncedUpdatePerUnitPrices = debounce(updatePerUnitPrices, 300);

    // ✅ Watch URL for variant change
    let lastVariantId = getCurrentVariantId();
    setInterval(() => {
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId !== lastVariantId) {
            lastVariantId = currentVariantId;
            debouncedUpdatePerUnitPrices();
        }
    }, 300);

    // ✅ Optional: MutationObserver fallback (in case Shopify does AJAX updates)
    var priceContainer = document.querySelector(".product__info-container, .price-container");
    if (priceContainer) {
        var observer = new MutationObserver(() => {
            debouncedUpdatePerUnitPrices();
        });
        observer.observe(priceContainer, { childList: true, subtree: true });
    }

    // ✅ Run once on initial page load
    updatePerUnitPrices();
});
